<template>
  <div>
    <div class="type_line">
      <el-radio-group v-model="account_id" size="small" @change="changeAccount">
        <el-radio-button
          v-for="item in accountList"
          :key="item.id"
          :label="item.id"
          >{{ item.name }}</el-radio-button
        >
      </el-radio-group>
    </div>
    <el-table
      :data="tableData"
      size="small"
      :header-cell-style="setHeader"
      border
    >
      <el-table-column
        label="变动原因"
        align="center"
        prop="show_name"
      ></el-table-column>
      <el-table-column
        label="变动说明"
        align="center"
        prop="text"
      ></el-table-column>
      <el-table-column
        label="变动数值"
        align="center"
        prop="show_num"
      ></el-table-column>
      <el-table-column label="剩余余额" align="center" prop="balance"></el-table-column>
      <el-table-column
        label="时间"
        align="center"
        prop="create_time"
      ></el-table-column>
    </el-table>
    <div class="page">
      <el-pagination
        background
        layout="prev, pager, next, total"
        :current-page="page"
        :total="total"
        :page-size="10"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getUserAccount, getUserBalanceLogs } from "@/api/vip";
import { mapGetters } from "vuex";
export default {
  props: {
    uid: {
      type: String,
      default: "",
    },
  },
  watch: {
    uid(val) {
      console.log("uid", val);
      this.getAccount();
    },
  },
  data() {
    return {
      tableData: [],
      accountList: [], //用户账户
      account_id: "", //账户id
      page: 1, // 页码
      total: 0, // 总数
      headerStyle: {
        //表头样式
        background: "rgba(250,250,250,1)",
        color: "#000000",
      },
      total_balance: 0,
    };
  },
  computed: {
    ...mapGetters(["token", "app_id"]),
  },
  mounted() {
    this.getAccount();
  },
  methods: {
    getAccount() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        uid: this.uid,
      };
      getUserAccount(data).then((res) => {
        if (res.code == 200) {
          this.accountList = [
            {
              id: res.data.wallet.id,
              name: "会员卡",
              balance: res.data.wallet.balance,
            },
          ];
          this.total_balance = res.data.wallet.balance;
          res.data.other.forEach((item) => {
            var i = {
              id: item.id,
              name: item.account_name,
              balance: item.balance,
            };
            this.accountList.push(i);
          });
          this.account_id = this.accountList[0].id;
          this.getData();
        } else {
          this.$message(res.msg);
        }
      });
    },
    getData() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        uid: this.uid,
        page: this.page,
        account_id: this.account_id,
      };
      getUserBalanceLogs(data).then((res) => {
        if (res.code == 200) {
          this.tableData = res.data.data;
          this.total = res.data.total;
          this.tableData.forEach((item) => {
            item.show_name =
              item.style == 0
                ? "签到送余额"
                : item.style == 1
                ? "线下买单"
                : item.style == 2
                ? "充值"
                : item.style == 3
                ? "后台变动"
                : item.style == 4
                ? "回退"
                : item.style == 5
                ? "其他"
                : item.style == 6
                ? "积分兑换"
                : item.style == 7
                ? "邀请新人"
                : item.style == 8
                ? "中奖发放"
                : item.style == 11
                ? "抖音活动"
                : "";
            item.show_num =
              item.type == 1
                ? "+" + item.amount
                : item.type == 2
                ? "-" + item.amount
                : "";
          });
        }
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getData();
    },
    changeAccount(val) {
      let item = this.accountList.find((x) => x.id == val);
      this.total_balance = item.balance;
      console.log("账户", item);
      this.page = 1;
      this.getData();
    },
    setHeader({ rowIndex }) {
      // 设置表头颜色
      if (rowIndex === 0) {
        return this.headerStyle;
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.type_line {
  margin-bottom: 20px;
}
.page {
  margin-top: 20px;
}
</style>
